import { I18nGenericData } from 'src/app/i18n';

export type SendLinkFormState = {
  lang: string;
  title: I18nGenericData<string>;
  body: I18nGenericData<string>;
};

type ModifyFieldAction = {
  type: 'MODIFY_FIELD';
  payload: {
    field: keyof SendLinkFormState;
    value: any;
  };
};

export type SendLinkFormAction = ModifyFieldAction;

export const sendLinkFormReducer = (state: SendLinkFormState, action: SendLinkFormAction): SendLinkFormState => {
  switch (action.type) {
    case 'MODIFY_FIELD':
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    default:
      return state;
  }
};
